import { publicClient, privateClient } from './client';
import { Contact } from './Contact';

const transactionsContact = (pub: boolean) => new Contact(pub ? publicClient : privateClient);
export default transactionsContact;
